import React from 'react'
import { connect } from 'react-redux'
import 'moment/locale/pt-br'
import '../../../css/components/react-datepicker.css';
import pt from 'date-fns/locale/pt';
import Titulo from '../../comum/Titulo';
import Autorizacao, { validaPerfis } from '../../../security/Autorizacao';
import { getFinanceiroEmpresa, PERFIL_ADMIN } from '../../../security/securityContext';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import DatePicker from 'react-datepicker/es';
import { renderFieldCheck, renderFieldSelect, requiredSelect } from '../../../util/inputs';
import { Field, reduxForm } from 'redux-form';
import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil';
import { URL } from '../../../util/ambienteActions';
import moment from 'moment';
import Select from 'react-select';
import buscarEmpresas from '../../../actions/empresa/buscarEmpresas';
import { TIPO_RELATORIO, GRUPOS, ITEM_TODAS_EMPRESAS } from '../../../util/constantsUtil';

registerLocale('pt', pt);
setDefaultLocale('pt');

export class PainelRelatorioGerencial extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tipoRelatorio: null,
            tipoDataBusca: 'tipoDataVenda',
            empresasSelecionadas: [],
            gruposSelecionados: [],
        };
        this.handleChangeTipoBusca = this.handleChangeTipoBusca.bind(this);
    }

    componentDidMount() {
        if (!validaPerfis([PERFIL_ADMIN])) {
            this.setState({ tipoRelatorio: 'EMPRESA' });
            this.setState({ empresasSelecionadas: [{ label: this.props.empresaSelecionada.nomeFantasia, value: this.props.empresaSelecionada.id }, ...this.state.empresasSelecionadas] });
            this.props.buscarEmpresas(this.props.empresaSelecionada.id);
        } else {
            this.props.buscarEmpresas();
        }
    }

    buscar(values) {
        if (values.resumido && !values.comissaoReimpressaoRecibo) {
            this.emitirRelatorioGerencialResumido(values)
        } else if (values.resumido && values.comissaoReimpressaoRecibo) {
            this.emitirRelatorioGerencialReimpressaoReciboResumido(values)
        } else if (values.comissaoReimpressaoRecibo) {
            this.emitirRelatorioGerencialComissaoRecibo(values);
        } else {
            this.emitirRelatorioGerencial(values)
        }

    }

    async emitirRelatorioGerencialComissaoRecibo(values) {
        const ehEncomenda = values.encomenda ? values.encomenda : false;

        let arquivo = '';
        if (ehEncomenda) {
            arquivo = 'Número pedido;Número Encomenda;Volumes;Nome empresa;Nome fantasia empresa;;Situação;Nome remetente;'
        } else {
            arquivo = 'Número pedido;Número bilhete;Nome empresa;Nome fantasia empresa;Situação;Nome passageiro;'
        }

        if (validaPerfis([PERFIL_ADMIN]) && !ehEncomenda) {
            arquivo += 'Telefone passageiro; ';
        }
        // arquivo += 'Custo cancelamento;Comissão;Imposto;'
        if (ehEncomenda) {
            arquivo += 'Valor encomenda;Valor Seguro;Valor Total;'
        } 
        // else {
        //     arquivo += 'Tarifa Seguro;Desconto;Acrescimo;Acrescimo(%);Taxa embarque;'
        // }

        // if (validaPerfis([PERFIL_ADMIN])) {
        //     arquivo += 'Taxa serviço;'
        // }

        // arquivo += 'Pedágio;'

        // if (!ehEncomenda) {
        //     arquivo += 'Valor passagem( - Desconto );Cupom(%);Descrição Cupom;'
        // }

        arquivo += 'Tx Comissão;Comissão;Valor Passagem;'

        if (this.state.tipoRelatorio === 'EMPRESA') {
            arquivo += 'Líquido empresa;'
        }

        arquivo += 'Vendedor;E-mail vendedor;Nome cliente;Data compra;Data da Transação;Rota;Data de partida;'

        if (ehEncomenda) {
            arquivo += 'Trecho de origem;Trecho de destino;Tipo de pagamento;Prestador;Veículo\n';
        } else {
            arquivo += 'Data embarque;Trecho de origem;Trecho de destino;Número da Poltrona;Tipo de pagamento;Tipo de emissão;Prestador;Veículo;Número Comissionamento Reimpressão Recibo;Descrição Reimpressao Recibo;Data Impressão;Usuário Reimpressão Recibo;Email Usuário Reimpressão Recibo\n';
        }

        let url = `${URL}/relatorio-gerencial-reimpressao-recibo/reimpressao-recibo?dataInicio=${moment(this.state.dataInicio)
            .format('YYYY-MM-DD')}&dataFim=${moment(this.state.dataFim)
                .format('YYYY-MM-DD')}&tipoBusca=${this.state.tipoDataBusca}&ehEncomenda=${ehEncomenda}`;
                
        if (this.state.tipoRelatorio === 'GRUPO') {
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => ['TODOS', 'SEM_GRUPO'].includes(it)).length > 0) {
                url = `${url}&empresasSemGrupo=${true}`;
            } 
            
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => it == 'TODOS').length > 0) {                                
                url = `${url}&grupos=${GRUPOS.filter(it => !['TODOS', 'SEM_GRUPO'].includes(it.value)).map(it => it.value)
                    .join(',')}`;
            } else {
                url = `${url}&grupos=${this.state.gruposSelecionados.map(it => it.value)
                    .join(',')}`;
            }
            
        }
        if (this.state.tipoRelatorio === 'EMPRESA') {
            if (this.state.empresasSelecionadas.length == 1 && this.state.empresasSelecionadas[0].label === ITEM_TODAS_EMPRESAS.label) {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.props.empresas.map(it => it.id)
                    .join(',')}`;

            } else {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.state.empresasSelecionadas.map(it => it.value)
                    .join(',')}`;
            }
        }

        let count = 0;
        let qtd = await this.recuperarQtdRegistrosComissaoRecibo(ehEncomenda);
        
        let totalParticoes = Math.ceil(qtd / 5000);
        for (let start = 0; start < totalParticoes; start += 1) {
            let retorno = await this.downloadParte(url, start);
            arquivo = `${arquivo}${retorno.map(it => {
                let valor = '';
                let prestador = it.prestador ? it.prestador : ' - ';
                // let porcentagemCupom = it.porcentagemCupom ? it.porcentagemCupom : '0';
                if (ehEncomenda) {
                    valor = `${it.numeroPedido};${it.numeroEncomenda};"${it.volumeEncomenda}";"${it.nomeEmpresa}";"${it.nomeFantasiaEmpresa}";"${it.nomeAgencia}";${it.situacao};"${it.nomeRemetente}";`
                } else {
                    valor = `${it.numeroPedido};${it.numeroReserva};"${it.nomeEmpresa}";"${it.nomeFantasiaEmpresa}";${it.situacao};"${it.nomePassageiro}";`
                }

                if (validaPerfis([PERFIL_ADMIN]) && !ehEncomenda) {
                    valor += `"${it.telefonePassageiro ? it.telefonePassageiro : ' - '}";`;
                }
                // valor += `"${it.custoCancelamento}";"${it.comissao}";"${it.imposto}";`
                if (ehEncomenda) {
                    valor += `"${it.valorEncomenda}";"${it.valorSeguroEncomenda}";"${it.valorTotalEncomenda}";`
                } 
                // else {
                    // valor += `"${it.tarifaSeguro}";"${it.desconto}";"${it.acrescimo}";"${it.percentualAcrescimo}";"${it.taxaEmbarque}";`
                // }

                // if (validaPerfis([PERFIL_ADMIN])) {
                //     valor += `"${it.taxaServico}";`
                // }

                // valor += `"${it.pedagio}";`

                // if (!ehEncomenda) {
                    // valor += `"${it.valorPassagem}";"${porcentagemCupom}";"${it.descricaoCupom}";`
                // }

                valor += `"${it.porcentagem}";"${it.comissao}";"${it.valorPassagem}";`

                if (this.state.tipoRelatorio === 'EMPRESA') {
                    valor += `"${it.valorLiquido}";`
                }
                valor += `"${it.vendedor}";"${it.email}";"${it.nomeCliente}";"${it.dataCompra}";"${it.dataHoraHistorico}";"${it.rota}";"${it.dataPartida}";`
                if (ehEncomenda) {
                    valor += `"${it.trechoOrigem}";"${it.trechoDestino}";"${it.tipoPagamento}";"${prestador}";"${it.descricaoVeiculo}"`;
                } else {
                    valor += `"${it.dataEmbarque}";"${it.trechoOrigem}";"${it.trechoDestino}";"${it.numeroPoltrona}";"${it.tipoPagamento}";"${it.tipoEmissao}";"${prestador}";"${it.descricaoVeiculo}";"${it.numeroComissionamentoReimpresaoRecibo}";"${it.descricaoReimpressaoRecibo}";"${it.dataImpressao}";"${it.nomeUsuarioReimpressaoRecibo}";"${it.emailUsuarioReimpressaoRecibo}"`;
                }

                return valor;
            }).join('\n')}\n`;

            count += 1;
            if (count === totalParticoes) {
                this.executarDownload(arquivo)
            }
        }
    }

    async emitirRelatorioGerencialResumido(values) {
        const ehEncomenda = values.encomenda ? values.encomenda : false;
        let arquivo = 'Empresa;Grupo;Mês/Ano;Situação;Quantidade;Valor Total;Valor Imposto;Cupom(Qtd. Utilizada);Tarifa Seguro\n';

        let url = `${URL}/relatorio-gerencial/resumido?dataInicio=${moment(this.state.dataInicio)
            .format('YYYY-MM-DD')}&dataFim=${moment(this.state.dataFim)
                .format('YYYY-MM-DD')}&tipoBusca=${this.state.tipoDataBusca}&ehEncomenda=${ehEncomenda}`;

        if (this.state.tipoRelatorio === 'GRUPO') {            
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => ['TODOS', 'SEM_GRUPO'].includes(it)).length > 0) {
                url = `${url}&empresasSemGrupo=${true}`;
            } 
            
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => it == 'TODOS').length > 0) {                                
                url = `${url}&grupos=${GRUPOS.filter(it => !['TODOS', 'SEM_GRUPO'].includes(it.value)).map(it => it.value)
                    .join(',')}`;
            } else {
                url = `${url}&grupos=${this.state.gruposSelecionados.map(it => it.value)
                    .join(',')}`;
            }
        }
        if (this.state.tipoRelatorio === 'EMPRESA') {

            if (this.state.empresasSelecionadas.length == 1 && this.state.empresasSelecionadas[0].label === ITEM_TODAS_EMPRESAS.label) {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.props.empresas.map(it => it.id)
                    .join(',')}`;
            } else {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.state.empresasSelecionadas.map(it => it.value)
                    .join(',')}`;
            }
        }

        let retorno = await axios.get(url, SLOW_REQUEST_CONFIG);

        arquivo = `${arquivo}${retorno.data.map(it => {

            let situacao = ehEncomenda ? it.situacaoPedido : it.situacaoReserva;
            let grupo = it.grupo ? it.grupo : ' - '

            let valor = `"${it.nomeEmpresa}";"${grupo}";"${it.mesAno}";"${situacao}";${it.quantidade};"${it.valorTotal}";"${it.valorTotalImposto}";"${it.qtdCupomUtilizado}";"${it.valorTotalTarifaSeguro}"`

            return valor;
        }).join('\n')}\n`;

        this.executarDownload(arquivo)
    }

    async emitirRelatorioGerencialReimpressaoReciboResumido(values) {
        const ehEncomenda = values.encomenda ? values.encomenda : false;      
        let arquivo = 'Empresa;Grupo;Mês/Ano;Situação;Quantidade;Valor Total;Valor Total Comissões\n';

        let url = `${URL}/relatorio-gerencial-reimpressao-recibo/resumido?dataInicio=${moment(this.state.dataInicio)
            .format('YYYY-MM-DD')}&dataFim=${moment(this.state.dataFim)
                .format('YYYY-MM-DD')}&tipoBusca=${this.state.tipoDataBusca}&ehEncomenda=${ehEncomenda}`;

        if (this.state.tipoRelatorio === 'GRUPO') {            
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => ['TODOS', 'SEM_GRUPO'].includes(it)).length > 0) {
                url = `${url}&empresasSemGrupo=${true}`;
            } 
            
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => it == 'TODOS').length > 0) {                                
                url = `${url}&grupos=${GRUPOS.filter(it => !['TODOS', 'SEM_GRUPO'].includes(it.value)).map(it => it.value)
                    .join(',')}`;
            } else {
                url = `${url}&grupos=${this.state.gruposSelecionados.map(it => it.value)
                    .join(',')}`;
            }
        }
        if (this.state.tipoRelatorio === 'EMPRESA') {

            if (this.state.empresasSelecionadas.length == 1 && this.state.empresasSelecionadas[0].label === ITEM_TODAS_EMPRESAS.label) {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.props.empresas.map(it => it.id)
                    .join(',')}`;
            } else {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.state.empresasSelecionadas.map(it => it.value)
                    .join(',')}`;
            }
        }

        let retorno = await axios.get(url, SLOW_REQUEST_CONFIG);

        arquivo = `${arquivo}${retorno.data.map(it => {

            let situacao = ehEncomenda ? it.situacaoPedido : it.situacaoReserva;
            let grupo = it.grupo ? it.grupo : ' - '
    
            let valor = `"${it.nomeEmpresa}";"${grupo}";"${it.mesAno}";"${situacao}";${it.quantidade};"${it.valorTotalReservas}";"${it.valorTotalComissao}"`

            return valor;
        }).join('\n')}\n`;

        this.executarDownload(arquivo)
    }

    async emitirRelatorioGerencial(values) {
        const ehEncomenda = values.encomenda ? values.encomenda : false;

        let arquivo = '';
        if (ehEncomenda) {
            arquivo = 'Número pedido;Número Encomenda;Volumes;Nome empresa;Nome fantasia empresa;Nome agência;Situação;Nome remetente;'
        } else {
            arquivo = 'Número pedido;Número bilhete;Número seguro;Nome empresa;Nome fantasia empresa;Nome agência;Situação;Nome passageiro;'
        }

        if (validaPerfis([PERFIL_ADMIN]) && !ehEncomenda) {
            arquivo += 'Telefone passageiro; ';
        }
        arquivo += 'Custo cancelamento;Custo remarcação;Comissão;Imposto;'
        if (ehEncomenda) {
            arquivo += 'Valor encomenda;Valor Seguro;Valor Total;'
        } else {
            arquivo += 'Tarifa Seguro;Desconto;Acrescimo;Acrescimo(%);Taxa embarque;'
        }

        if (validaPerfis([PERFIL_ADMIN])) {
            arquivo += 'Taxa serviço;'
        }

        arquivo += 'Pedágio;'

        if (!ehEncomenda) {
            arquivo += 'Valor passagem( - Desconto );Cupom(%);Descrição Cupom;'
        }

        arquivo += 'Valor pedido;'

        if (this.state.tipoRelatorio === 'EMPRESA') {
            arquivo += 'Líquido empresa;'
        }

        arquivo += 'Vendedor;E-mail vendedor;Nome cliente;Data compra;Data da Transação;Rota;Data de partida;'

        if (ehEncomenda) {
            arquivo += 'Trecho de origem;Trecho de destino;Tipo de pagamento;Prestador;Veículo\n';
        } else {
            arquivo += 'Data embarque;Trecho de origem;Trecho de destino;Número da Poltrona;Tipo de pagamento;Tipo de emissão;Prestador;Veículo;API;Emissão BPe\n';
        }

        let url = `${URL}/relatorio-gerencial?dataInicio=${moment(this.state.dataInicio)
            .format('YYYY-MM-DD')}&dataFim=${moment(this.state.dataFim)
                .format('YYYY-MM-DD')}&tipoBusca=${this.state.tipoDataBusca}&ehEncomenda=${ehEncomenda}`;
        
        if (this.state.tipoRelatorio === 'GRUPO') {
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => ['TODOS', 'SEM_GRUPO'].includes(it)).length > 0) {
                url = `${url}&empresasSemGrupo=${true}`;
            } 
            
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => it == 'TODOS').length > 0) {                                
                url = `${url}&grupos=${GRUPOS.filter(it => !['TODOS', 'SEM_GRUPO'].includes(it.value)).map(it => it.value)
                    .join(',')}`;
            } else {
                url = `${url}&grupos=${this.state.gruposSelecionados.map(it => it.value)
                    .join(',')}`;
            }
            
        }
        if (this.state.tipoRelatorio === 'EMPRESA') {
            if (this.state.empresasSelecionadas.length == 1 && this.state.empresasSelecionadas[0].label === ITEM_TODAS_EMPRESAS.label) {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.props.empresas.map(it => it.id)
                    .join(',')}`;

            } else {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.state.empresasSelecionadas.map(it => it.value)
                    .join(',')}`;
            }
        }

        let count = 0;
        let qtd = await this.recuperarQtdRegistros(ehEncomenda);
        let totalParticoes = Math.ceil(qtd / 5000);
        for (let start = 0; start < totalParticoes; start += 1) {
            let retorno = await this.downloadParte(url, start);
            arquivo = `${arquivo}${retorno.map(it => {
                let valor = '';
                let prestador = it.prestador ? it.prestador : ' - ';
                let porcentagemCupom = it.porcentagemCupom ? it.porcentagemCupom : '0';
                if (ehEncomenda) {
                    valor = `${it.numeroPedido};${it.numeroEncomenda};"${it.volumeEncomenda}";"${it.nomeEmpresa}";"${it.nomeFantasiaEmpresa}";"${it.nomeAgencia}";${it.situacao};"${it.nomeRemetente}";`
                } else {
                    valor = `${it.numeroPedido};${it.numeroReserva};${it.numeroSeguro};"${it.nomeEmpresa}";"${it.nomeFantasiaEmpresa}";"${it.nomeAgencia}";${it.situacao};"${it.nomePassageiro}";`
                }

                if (validaPerfis([PERFIL_ADMIN]) && !ehEncomenda) {
                    valor += `"${it.telefonePassageiro ? it.telefonePassageiro : ' - '}";`;
                }
                valor += `"${it.custoCancelamento}";"${it.custoRemarcacao}";"${it.comissao}";"${it.imposto}";`
                if (ehEncomenda) {
                    valor += `"${it.valorEncomenda}";"${it.valorSeguroEncomenda}";"${it.valorTotalEncomenda}";`
                } else {
                    valor += `"${it.tarifaSeguro}";"${it.desconto}";"${it.acrescimo}";"${it.percentualAcrescimo}";"${it.taxaEmbarque}";`
                }

                if (validaPerfis([PERFIL_ADMIN])) {
                    valor += `"${it.taxaServico}";`
                }

                valor += `"${it.pedagio}";`

                if (!ehEncomenda) {
                    valor += `"${it.valorPassagem}";"${porcentagemCupom}";"${it.descricaoCupom}";`
                }

                valor += `"${it.valorPedido}";`

                if (this.state.tipoRelatorio === 'EMPRESA') {
                    valor += `"${it.valorLiquido}";`
                }
                valor += `"${it.vendedor}";"${it.email}";"${it.nomeCliente}";"${it.dataCompra}";"${it.dataHoraHistorico}";"${it.rota}";"${it.dataPartida}";`
                if (ehEncomenda) {
                    valor += `"${it.trechoOrigem}";"${it.trechoDestino}";"${it.tipoPagamento}";"${prestador}";"${it.descricaoVeiculo}"`;
                } else {
                    valor += `"${it.dataEmbarque}";"${it.trechoOrigem}";"${it.trechoDestino}";"${it.numeroPoltrona}";"${it.tipoPagamento}";"${it.tipoEmissao}";"${prestador}";"${it.descricaoVeiculo}";"${it.api}";"${it.bpeEmitido}"`;
                }

                return valor;
            }).join('\n')}\n`;

            count += 1;
            if (count === totalParticoes) {
                this.executarDownload(arquivo)
            }
        }
    }

    async recuperarQtdRegistros(ehEncomenda) {
        let urlQtdRegistros = `${URL}/relatorio-gerencial/quantidade-registros?dataInicio=${moment(this.state.dataInicio)
            .format('YYYY-MM-DD')}&dataFim=${moment(this.state.dataFim)
                .format('YYYY-MM-DD')}&empresaId=${this.props.empresaSelecionada.id}&tipoBusca=${this.state.tipoDataBusca}&ehEncomenda=${ehEncomenda}`;

        if (this.state.tipoRelatorio === 'GRUPO') {
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => ['TODOS', 'SEM_GRUPO'].includes(it)).length > 0) {
                urlQtdRegistros = `${urlQtdRegistros}&empresasSemGrupo=${true}`;
            } 
            
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => it == 'TODOS').length > 0) {                
                urlQtdRegistros = `${urlQtdRegistros}&grupos=${GRUPOS.filter(it => !['TODOS', 'SEM_GRUPO'].includes(it.value)).map(it => it.value)
                    .join(',')}`;
            } else {
                urlQtdRegistros = `${urlQtdRegistros}&grupos=${this.state.gruposSelecionados.map(it => it.value)
                    .join(',')}`;
            }

        }
        if (this.state.tipoRelatorio === 'EMPRESA') {
            if (this.state.empresasSelecionadas.length == 1 && this.state.empresasSelecionadas[0].value === ITEM_TODAS_EMPRESAS.value) {
                urlQtdRegistros = `${urlQtdRegistros}&empresas=${this.props.empresas.map(it => it.id)
                    .join(',')}`;

            } else {
                urlQtdRegistros = `${urlQtdRegistros}&empresas=${this.state.empresasSelecionadas.map(it => it.value)
                    .join(',')}`;
            }
        }

        let retorno = await axios.get(urlQtdRegistros, SLOW_REQUEST_CONFIG);
        return retorno.data;
    }

    async recuperarQtdRegistrosComissaoRecibo(ehEncomenda) {        
        let urlQtdRegistros = `${URL}/relatorio-gerencial-reimpressao-recibo/quantidade-registros?dataInicio=${moment(this.state.dataInicio)
            .format('YYYY-MM-DD')}&dataFim=${moment(this.state.dataFim)
                .format('YYYY-MM-DD')}&empresaId=${this.props.empresaSelecionada.id}&tipoBusca=${this.state.tipoDataBusca}&ehEncomenda=${ehEncomenda}`;

        if (this.state.tipoRelatorio === 'GRUPO') {
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => ['TODOS', 'SEM_GRUPO'].includes(it)).length > 0) {
                urlQtdRegistros = `${urlQtdRegistros}&empresasSemGrupo=${true}`;
            } 
            
            if (this.state.gruposSelecionados.map(it => it.value).filter(it => it == 'TODOS').length > 0) {                
                urlQtdRegistros = `${urlQtdRegistros}&grupos=${GRUPOS.filter(it => !['TODOS', 'SEM_GRUPO'].includes(it.value)).map(it => it.value)
                    .join(',')}`;
            } else {
                urlQtdRegistros = `${urlQtdRegistros}&grupos=${this.state.gruposSelecionados.map(it => it.value)
                    .join(',')}`;
            }

        }
        if (this.state.tipoRelatorio === 'EMPRESA') {
            if (this.state.empresasSelecionadas.length == 1 && this.state.empresasSelecionadas[0].value === ITEM_TODAS_EMPRESAS.value) {
                urlQtdRegistros = `${urlQtdRegistros}&empresas=${this.props.empresas.map(it => it.id)
                    .join(',')}`;

            } else {
                urlQtdRegistros = `${urlQtdRegistros}&empresas=${this.state.empresasSelecionadas.map(it => it.value)
                    .join(',')}`;
            }
        }

        let retorno = await axios.get(urlQtdRegistros, SLOW_REQUEST_CONFIG);
        return retorno.data;
    }

    async downloadParte(url, start) {
        let urlReq = `${url}&pagina=${start}`;
        let retorno = await axios.get(urlReq, SLOW_REQUEST_CONFIG);
        return retorno.data;
    }

    executarDownload(arquivo) {
        let a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], { type: 'text/csv;' }));
        a.download = `Relatório Gerencial de ${moment(this.state.dataInicio)
            .format('DD/MM/YYYY')} até ${moment(this.state.dataFim)
                .format('DD/MM/YYYY')}.csv`;

        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
    }

    exibirCampoBusca() {
        if (this.props.resumoFinanceiroInicial.length) {
            return (<React.Fragment>
                <div className="input-group mb-3 mt-3">
                    <span className="input-group-prepend">
                        <button id="btn-campo-busca-processo" type="submit"
                            className="input-group-text bg-white btn-campo-busca" disabled={true}>
                            <i className="material-icons">&#xe8b6;</i>
                        </button>
                    </span>
                    <input className="form-control form-control-lg campo-busca"
                        type="text"
                        id="campo-busca-legitimado"
                        onChange={this.submeterBusca}
                        autoComplete="off"
                        placeholder="Buscar na lista abaixo" />
                </div>
            </React.Fragment>);
        }
    }

    exibirComboGrupos() {
        return (
            <React.Fragment>
                <Select
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    value={this.state.gruposSelecionados}
                    isMulti
                    placeholder='Selecione...'
                    styles={{
                        control: base => ({
                            ...base,
                            minHeight: 32,
                            fontSize: 16,
                            width: '100%',
                            borderColor: '#e4e7ea',
                            cursor: 'pointer'
                        })
                    }}
                    options={GRUPOS}
                    onChange={event => this.setState({ gruposSelecionados: [...event] })}
                />
            </React.Fragment>
        )
    }

    retornaTodasEmpresas() {
        const empresasMapeadas = this.props.empresas.map(elemento => ({
            label: elemento.nomeFantasia,
            value: elemento.id
        }));

        return [...empresasMapeadas, ITEM_TODAS_EMPRESAS];
    }

    exibirComboEmpresas() {
        return (
            <div>
                <Select
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    value={this.state.empresasSelecionadas}
                    isMulti
                    placeholder='Selecione...'
                    styles={{
                        control: base => ({
                            ...base,
                            minHeight: 32,
                            fontSize: 16,
                            width: '100%',
                            borderColor: '#e4e7ea',
                            cursor: 'pointer'
                        })
                    }}
                    options={this.retornaTodasEmpresas()}
                    onChange={event => this.setState({ empresasSelecionadas: [...event] })}
                />
            </div>
        )
    }

    handleChangeTipoBusca(event) {
        this.setState({ tipoDataBusca: event.target.id });
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;

        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="container-padrao" style={{ height: '100%' }}>
                    <Titulo texto="Relatório Gerencial" urlRetorno="/menu-relatorio" />
                    <form onSubmit={handleSubmit(this.buscar.bind(this))}>
                        <div className="vx-form-panel">
                            <div className='mt-2'>
                                <Field type="checkbox" name='resumido' component={renderFieldCheck}
                                    label="Resumido?"
                                    css="form-check-input" readOnly={false} />
                            </div>
                            <div className='mt-n1'>
                                <Field type="checkbox" name='encomenda' component={renderFieldCheck}
                                    label="Encomendas"
                                    css="form-check-input" readOnly={false}
                                />
                            </div>
                            <div className='mt-n1'>
                                <Field type="checkbox" name='comissaoReimpressaoRecibo' component={renderFieldCheck}
                                    label="Comissão Reimpressão"
                                    css="form-check-input" readOnly={false}
                                />
                            </div>
                            <div className='row mt-2 mb-2'>
                                <div className='col-md-2 col-12 col-sm-12'>
                                    <span className="label-data">Buscar por</span>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" id="tipoDataVenda"
                                            onChange={this.handleChangeTipoBusca}
                                            checked={this.state.tipoDataBusca === 'tipoDataVenda'} />
                                        <label className="form-check-label" htmlFor="tipoEmpresaAtual">
                                            Data de venda
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" id="tipoDataEmbarque"
                                            onChange={this.handleChangeTipoBusca}
                                            checked={this.state.tipoDataBusca === 'tipoDataEmbarque'} />
                                        <label className="form-check-label" htmlFor="tipoTodasEmpresa">
                                            Data de embarque
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" id="tipoDataEmbarqueFuturo"
                                            onChange={this.handleChangeTipoBusca}
                                            checked={this.state.tipoDataBusca === 'tipoDataEmbarqueFuturo'} />
                                        <label className="form-check-label" htmlFor="tipoDataEmbarqueFuturo">
                                            Data de embarque Futuro
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" id="tipoDataTransacao"
                                            onChange={this.handleChangeTipoBusca}
                                            checked={this.state.tipoDataBusca === 'tipoDataTransacao'} />
                                        <label className="form-check-label" htmlFor="tipoDataTransacao">
                                            Data da Transação
                                        </label>
                                    </div>
                                </div>
                                <div className='col-md-2 col-12 col-sm-12'>
                                    <span className="label-data">De</span>
                                    <DatePicker
                                        value={this.state.dataInicio}
                                        className='form-control form-control-lg campo-busca data-itinerario'
                                        locale="pt-BR"
                                        onChange={date => {
                                            this.setState({ dataInicio: date });
                                        }
                                        }
                                        selected={this.state.dataInicio}
                                        dateFormat="dd/MM/yyyy" />
                                </div>
                                <div className='col-md-2 col-12 col-sm-12'>
                                    <span className="label-data ">Até</span>
                                    <DatePicker
                                        className='form-control form-control-lg campo-busca data-itinerario'
                                        locale="pt-BR"
                                        value={this.state.dataFim}
                                        selected={this.state.dataFim}
                                        onChange={date => {
                                            this.setState({ dataFim: date });
                                        }
                                        }
                                        dateFormat="dd/MM/yyyy" />
                                </div>
                                {validaPerfis([PERFIL_ADMIN]) &&
                                    <div className='col-md-2 col-12 col-sm-12'>
                                        <span className="label-dat">Tipo de relatório</span>
                                        <div className='mt-1'>
                                            <Field name='tipoRelatorio'
                                                options={TIPO_RELATORIO}
                                                onChange={event => this.setState({ tipoRelatorio: event.value })}
                                                component={renderFieldSelect}
                                                placeholder='Selecione...' validate={requiredSelect} />
                                        </div>
                                    </div>}

                                {this.state.tipoRelatorio === 'GRUPO' ? <div className='col-md-3 col-12 col-sm-12'>
                                    <span className="label-dat">Grupo</span>
                                    <div className='mt-1'>
                                        <Field id='grupo' name='grupo'
                                            component={this.exibirComboGrupos.bind(this)} />
                                    </div>
                                </div> : ''}
                                {this.state.tipoRelatorio === 'EMPRESA' ? <div className='col-md-3 col-12 col-sm-12'>
                                    <span className="label-dat">Empresa</span>
                                    <div className='mt-1'>
                                        <Field id='empresa' name='empresa'
                                            component={this.exibirComboEmpresas.bind(this)} />
                                    </div>
                                </div> : ''}
                            </div>
                        </div>
                    <div className="text-center mt-3 mb-4">
                        <button
                            disabled={invalid || submitting
                                || !this.state.dataInicio
                                || !this.state.dataFim
                                || (this.state.tipoRelatorio === 'GRUPO' && !this.state.gruposSelecionados.length)
                                || (this.state.tipoRelatorio === 'EMPRESA' && !this.state.empresasSelecionadas.length)}
                            type="submit" className="btn vx-btn-acao-dark">
                            <i className="material-icons">file_download</i>
                            Gerar Relatório
                        </button>
                    </div>
                </form>
                </div>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => (
    {
        empresas: state.empresas,
        empresaSelecionada: state.empresaSelecionada,
    });


export default connect(mapStateToProps,
    { buscarEmpresas })(reduxForm({
        form: 'formRelatorioGerencial',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true
    })(PainelRelatorioGerencial));
